export var LaboratoryListPageDataTest;
(function (LaboratoryListPageDataTest) {
    LaboratoryListPageDataTest["UserLink"] = "laboratoryListPage_userLink";
    LaboratoryListPageDataTest["OpenMenu"] = "laboratoryListPage_openMenu";
    LaboratoryListPageDataTest["Create"] = "laboratoryListPage_create";
    LaboratoryListPageDataTest["IntegrationType"] = "laboratoryListPage_integrationType";
    LaboratoryListPageDataTest["LegalEntities"] = "laboratoryListPage_legalEntities";
    LaboratoryListPageDataTest["ID"] = "laboratoryListPage_id";
    LaboratoryListPageDataTest["Name"] = "laboratoryListPage_name";
    LaboratoryListPageDataTest["Email"] = "laboratoryListPage_email";
    LaboratoryListPageDataTest["Edit"] = "laboratoryListPage_edit";
    LaboratoryListPageDataTest["Delete"] = "laboratoryListPage_delete";
})(LaboratoryListPageDataTest || (LaboratoryListPageDataTest = {}));
